import React from "react";
import { Button, Card, CardBody } from "reactstrap";
import styles from "./DynamicCard.module.scss";
import classNames from "classnames";

const DynamicCard = ({ title, value, icon, muted = false }) => {
    return (
        <Card className={styles.dynamicCard}>
            <CardBody className={styles.cardBody}>
                <p className={styles.title}>{title}</p>
                <div className={styles.content}>
                    {typeof value === "object" && value.isButton ? (
                        <Button
                            color="link"
                            className={styles.valueBtn}
                            onClick={value.onClick}
                        >
                            {value.label}
                        </Button>
                    ) : (
                        <p
                            className={classNames({
                                [styles.value]: !muted,
                                [styles["muted-value"]]: muted,
                            })}
                        >
                            {value}
                        </p>
                    )}
                    {icon && <span className={styles.icon}>{icon}</span>}
                </div>
            </CardBody>
        </Card>
    );
};
export default DynamicCard;